import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import api from "../../services/api";
import { setBreadcrumbItems } from "../../store/actions";


const UpdateStudentEligibilityStatus = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [registration, setRegistration] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [updating, setUpdating] = useState(false);

  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Student Registrations", link: "#" },
    { title: "Student Registrations List", link: "#" },
    { title: "Payment Eligibility", link: "#" },
  ];

  useEffect(() => {
    const getStudentRegistration = async () => {
      try {
        const response = await axios.get(
          `${backendUrl}get-student-registration-by-id/${id}`
        );
        console.log("get-student-registration-by-id response:", response.data);

        if (response.status === 200) {
          setRegistration(response.data.student_registration);

          const paymentStatus =
            response.data.student_registration?.payment_status === 1
              ? "Active"
              : "Inactive";

          setSelectedStatus({ label: paymentStatus, value: paymentStatus });
        }
      } catch (err) {
        console.error("Failed to fetch student registration:", err);
        toast.error("Failed to fetch student registration");
      } finally {
        setLoading(false);
      }
    };

    getStudentRegistration();
    props.setBreadcrumbItems("Payment Eligibility", breadcrumbItems);
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const statusOptions = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];

  const handleChangeStatus = (option) => {
    setSelectedStatus(option);
  };

  const handleUpdate = async () => {
    if (!selectedStatus) {
      toast.warning("Please select a status before updating.");
      return;
    }

    // Optional: avoid unnecessary call if status same as current local status
    const currentStatus =
      registration?.payment_status === 1 ? "Active" : "Inactive";
    if (selectedStatus.value === currentStatus) {
      toast.info(`Payment eligibility is already ${currentStatus}.`);
      return;
    }

    try {
      setUpdating(true);
      const payload = { status: selectedStatus.value };
      console.log("Request payload to update-payment-eligibility-status:", payload);

      const response = await api.put(
        `${backendUrl}update-payment-eligibility-status/${id}`,
        payload
      );

      console.log(
        "update-payment-eligibility-status success response:",
        response.data
      );

      if (response.status === 200) {
        toast.success(
          `Payment eligibility for ${registration?.roll_no || "student"} is updated successfully`
        );
        setSelectedStatus(null);
        setTimeout(() => {
          navigate("/student-registrations-list");
        }, 2000);
      }
    } catch (err) {
      console.error(
        "update-payment-eligibility-status error:",
        err.response?.data || err
      );

      if (err.response) {
        const { data } = err.response;

        // Payment status already same
        if (data.errorCode === "PAYMENT_STATUS_ALREADY_EXISTS") {
          toast.error(data.message || "Payment status already set.");
          return;
        }

        // Payments already exist in same course (from new backend logic)
        if (data.errorCode === "PAYMENTS_EXIST_FOR_COURSE") {
          let msg = data.message || "Student has existing payments in this course.";

          const techNames =
            data.details?.technologies?.length > 0
              ? data.details.technologies
                  .map((t) => t.technology_name || "Unknown Technology")
                  .join(", ")
              : "";

          if (techNames) {
            msg += ` (Payments found in: ${techNames})`;
          }

          toast.error(msg);
          return;
        }

        toast.error(data.message || "Failed to update payment eligibility");
      } else {
        toast.error("Network error while updating payment eligibility");
      }
    } finally {
      setUpdating(false);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        transition={Bounce}
      />

      <Card className="shadow-sm border-0">
        <CardBody>
          <CardTitle className="text-primary fw-bold fs-3 mb-4 text-center">
            Update Payment Eligibility
          </CardTitle>

          {loading ? (
            <div className="text-center my-5">
              <Spinner color="primary" />
            </div>
          ) : (
            <Row className="justify-content-center">
              <Col md="6">
                <div className="mb-4">
                  <Label className="fw-semibold text-dark">Roll No</Label>
                  <div className="border rounded p-2 bg-light text-dark">
                    {registration?.roll_no || "N/A"}
                  </div>
                </div>

                <div className="mb-4">
                  <Label className="fw-semibold text-dark">Select Status</Label>
                  <Select
                    value={selectedStatus}
                    onChange={handleChangeStatus}
                    options={statusOptions}
                    placeholder="Choose Option"
                    classNamePrefix="select"
                  />
                </div>

                <div className="text-center">
                  <Button
                    color="primary"
                    className="px-4"
                    onClick={handleUpdate}
                    disabled={updating}
                  >
                    {updating ? "Updating..." : "Update"}
                  </Button>
                </div>
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(
  UpdateStudentEligibilityStatus
);
